import { Initial } from "./routes";

export const App = () => {
  return (    
      <Initial />
  );
};
